import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import Formatter from "../../Localization/Formatter";
import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";

class AgreementWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);
    const agencyFee: AgencyFeeInterface = this.component.props.app.agencyFees.find((agencyFee: AgencyFeeInterface) => agencyFee.id === id);

    this.component.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_CLEAR
    });

    let vatPercentage = "";

    if (agencyFee && agencyFee.fixedFee) {
      const vatPercentageNumber = Math.round(agencyFee.vat / (agencyFee.fixedFee - agencyFee.vat) * 100);

      if (!isNaN(vatPercentageNumber)) {
        vatPercentage = Formatter.simpleFormatNumber(vatPercentageNumber, false, false);
      }
    }

    this.component.setState({
      agencyFee: agencyFee,
      currency: agencyFee && agencyFee.currency.getCurrencyId(),
      fixedFee: agencyFee && ((!agencyFee.fixedFee && agencyFee.fixedFee !== 0) ? "" : Formatter.simpleFormatNumber(agencyFee.fixedFee)),
      percentageFee: agencyFee && Formatter.simpleFormatNumber(agencyFee.percentageFee, false),
      fixedPlusPercentageMode: agencyFee && agencyFee.fixedPlusPercentageMode,
      vat: agencyFee && (!agencyFee.vat ? "" : Formatter.simpleFormatNumber(agencyFee.vat)),
      vatPercentage: vatPercentage,
      firstDate: agencyFee && (!agencyFee.firstDate ? null : agencyFee.firstDate),
      lastDate: agencyFee && (!agencyFee.lastDate ? null : agencyFee.lastDate),
      dateChoice: !!agencyFee && agencyFee.firstDate ? "firstDate" : "contractDate",
      firstDateError: "",
      chargeTypeIds: agencyFee?.chargeTypeIds || [],
      isEndAgencyFeeDialogOpen: false,
      repeatPeriod: agencyFee?.repeatPeriod,
      assignmentServiceStatus: agencyFee?.assignmentServiceStatus,
      date: agencyFee?.date,
    });
  }
}

export default new AgreementWillMount();
